import { render } from "./registration.html?vue&type=template&id=5db4e941&external"
import script from "./registration.js?vue&type=script&lang=js&external"
export * from "./registration.js?vue&type=script&lang=js&external"

import "./UserRegistration.vue?vue&type=style&index=0&id=5db4e941&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__